import {projectHelper} from '../../../../../../lib-sat/misc/project-helper';
import {cookieHelper} from "../../../../../helper/cookie";

class HintManager {
    isShowCreatorStudioHint = false;

    constructor() {
    }

    showCreatorStudioHint() {
        if (projectHelper.isOnlineConvert() !== true && projectHelper.isImg2go() !== true) {
            return false;
        }

        if (this.isShowCreatorStudioHint === true) {
            return true;
        }

        let counter = cookieHelper.getCookieValue('hint_creator_studio');

        if (null === counter) {
            counter = 0;
        }

        counter++;

        cookieHelper.setCookie('hint_creator_studio', counter, 86400);

        if (counter > 1) {
            return false;
        }

        this.isShowCreatorStudioHint = true;
    }

    showOcrHint(job) {
        const conversion = job?.conversion[0];
        const inputs = job?.input;
        const operation = job?.sat?.operation;

        if (!projectHelper.isPdf2go() && !projectHelper.isOnlineConvert()) {
            return false;
        }

        if (
            operation !== 'convertPdfToWord' &&
            operation !== 'converttoword' &&
            operation !== 'toolpdftoword' &&
            operation !== 'converttodocx'
        ) {
            return false;
        }

        if (conversion?.category !== 'document') {
            return false;
        }

        if (conversion?.options?.ocr === true) {
            return false;
        }

        let textPagePercentage = 0;

        inputs.forEach((input) => {
            textPagePercentage += input.metadata.textpages_percentage;
        });

        let averageTextPagePercentage = textPagePercentage / inputs.length;

        if (averageTextPagePercentage > 30) {
            return false;
        }

        return true;
    }

}

export default new HintManager();
